let audioContext = null

function initAudioContext() {
  if (!audioContext) {
    audioContext = new (window.AudioContext || window.webkitAudioContext)()
  }
  return audioContext
}

async function ensureAudioContext() {
  const ctx = initAudioContext()
  if (ctx.state === 'suspended') {
    await ctx.resume()
  }
  return ctx
}

function shouldPlaySound() {
  if (window.matchMedia?.('(prefers-reduced-motion: reduce)').matches) {
    return false
  }
  return true
}

export async function loadAudioBuffer(url) {
  try {
    const ctx = initAudioContext()
    const response = await fetch(url)
    if (!response.ok) return null
    
    const arrayBuffer = await response.arrayBuffer()
    return await ctx.decodeAudioData(arrayBuffer)
  } catch (error) {
    console.debug('Failed to load audio:', error)
    return null
  }
}

export async function playAudioBuffer(audioBuffer, volume = 0.15) {
  if (!shouldPlaySound() || !audioBuffer) return

  try {
    const ctx = await ensureAudioContext()
    const source = ctx.createBufferSource()
    const gainNode = ctx.createGain()
    
    source.buffer = audioBuffer
    gainNode.gain.value = volume
    source.connect(gainNode)
    gainNode.connect(ctx.destination)
    
    source.start(0)
  } catch (error) {
    console.debug('Sound playback failed:', error)
  }
}

